/**
 * Transaction/order display helpers for dashboard tables.
 */

import { formatVnDateTimeShort } from './vnDateTime';

/** Format amount as VND (e.g. "150.000 đ") */
export function formatCurrencyVND(amount: number): string {
  return (
    new Intl.NumberFormat('vi-VN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number.isFinite(amount) ? amount : 0) + ' đ'
  );
}

/** Format date for display: "dd/MM HH:mm" (Vietnam timezone). */
export function formatDateTimeVN(date: string | Date): string {
  return formatVnDateTimeShort(date);
}

/** Truncate middle of string with ellipsis (e.g. "#ORD17705583" -> "#ORD177...583") */
export function truncateMiddle(str: string, head = 6, tail = 4): string {
  if (!str || str.length <= head + tail + 3) return str;
  return `${str.slice(0, head)}...${str.slice(-tail)}`;
}

export interface TxnStatusConfig {
  label: string;
  variant:
    | 'pending'
    | 'processing'
    | 'success'
    | 'cancelled'
    | 'failed'
    | 'unknown';
}

/** Map raw status code to short label + variant for badge styling */
export function mapTxnStatus(statusCode: string): TxnStatusConfig {
  const s = (statusCode || '').toLowerCase().trim();
  const known: Record<string, TxnStatusConfig> = {
    pending_payment: { label: 'Chờ thanh toán', variant: 'pending' },
    pending: { label: 'Chờ xử lý', variant: 'pending' },
    paid: { label: 'Đã thanh toán', variant: 'success' },
    confirmed: { label: 'Đã xác nhận', variant: 'processing' },
    preparing: { label: 'Đang chuẩn bị', variant: 'processing' },
    ready: { label: 'Sẵn sàng', variant: 'processing' },
    delivering: { label: 'Đang giao', variant: 'processing' },
    delivered: { label: 'Hoàn thành', variant: 'success' },
    completed: { label: 'Hoàn thành', variant: 'success' },
    cancelled: { label: 'Đã huỷ', variant: 'cancelled' },
    payment_failed: { label: 'Thất bại', variant: 'failed' },
    failed: { label: 'Thất bại', variant: 'failed' },
  };
  return known[s] ?? { label: 'Khác', variant: 'unknown' };
}
